import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function Immigration() {
    
  return (
   <motion.div
      className="max-w-4xl mx-auto px-6 py-12 text-center"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <h1 className="text-3xl md:text-4xl font-bold mb-6">Immigration Law</h1>
      <p className="text-lg text-gray-700 leading-relaxed mb-8 text-left">
        Navigating Canada’s immigration system can be complex and overwhelming—especially when faced with legal setbacks, urgent personal circumstances, or procedural barriers. Whether you are applying for judicial review of immigration decisions, Humanitarian & Compassionate (H&C) applications, or facing inadmissibility concerns, we offer strategic, compassionate, and client-focused immigration guidance to individuals and families striving to build a secure future in Canada.
We understand that behind every file is a deeply personal story. That is why we take the time to understand your unique circumstances, explain you your legal options clearly, and build a thoughtful, evidence-based strategy tailored to your goals.
From preparing detailed submissions to representing you in complex review proceedings, we are dedicated to helping you overcome challenges and move forward with confidence.

      </p>
      <Link
        to="/contact"
        className="inline-block px-6 py-3 rounded-lg bg-blue-900 text-white font-semibold shadow hover:bg-blue-800 transition"
      >
        Request Consultation
      </Link>
    </motion.div>
  );
}
